import { combineReducers } from 'redux';
import initialization from './initialization';
import counter from './counter';
import drawer from './drawer';
import room from './room';
import activity from './global';
import drafts from './drafts';
const rootReducers = {
    initialization,
    counter,
    drawer,
    room,
    activity,
    drafts
};
export default combineReducers(rootReducers);

//# sourceMappingURL=index.js.map